import React, { useState } from 'react';

// ⚠️ Change these!
const ADMIN_EMAIL    = 'admin@jsmstock.com';
const ADMIN_PASSWORD = 'JsmAdmin@2026!';

export default function AdminLogin({ onAdminLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Email + Password போடுங்கள்!');
      return;
    }
    setLoading(true);
    setError('');

    // Simulate small delay:
    await new Promise(r => setTimeout(r, 800));

    if (email === ADMIN_EMAIL &&
        password === ADMIN_PASSWORD) {
      // Save admin session:
      sessionStorage.setItem(
        'admin_logged_in', 'true'
      );
      sessionStorage.setItem(
        'admin_email', email
      );
      onAdminLogin();
    } else {
      setError(
        'Wrong email or password!'
      );
    }
    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div style={s.page}>
      <div style={s.card}>

        {/* Logo */}
        <div style={s.logoBox}>
          <span style={s.logoIcon}>📦</span>
          <h1 style={s.logoText}>JSMSTOCK</h1>
          <p style={s.tagline}>
            உங்கள் கடை, உங்கள் கையில்!
          </p>
        </div>

        {/* Admin badge */}
        <div style={s.adminBadge}>
          🔐 Admin Portal
        </div>

        {/* Form */}
        <div style={s.form}>
          {error && (
            <div style={s.errorBox}>
              ❌ {error}
            </div>
          )}

          <div style={s.field}>
            <label style={s.label}>
              Admin Email
            </label>
            <input
              style={s.input}
              type="email"
              placeholder="admin@jsmstock.com"
              value={email}
              onChange={e =>
                setEmail(e.target.value)
              }
              onKeyPress={handleKeyPress}
              autoComplete="off"
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>
              Password
            </label>
            <div style={s.passRow}>
              <input
                style={{...s.input, flex:1}}
                type={showPass ? 'text' : 'password'}
                placeholder="Admin password"
                value={password}
                onChange={e =>
                  setPassword(e.target.value)
                }
                onKeyPress={handleKeyPress}
              />
              <button
                style={s.eyeBtn}
                onClick={() =>
                  setShowPass(!showPass)
                }
              >
                {showPass ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <button
            style={{
              ...s.loginBtn,
              opacity: loading ? 0.7 : 1
            }}
            onClick={handleLogin}
            disabled={loading}
          >
            {loading
              ? '⏳ Logging in...'
              : '🔐 Admin Login'
            }
          </button>
        </div>

        {/* Customer link */}
        <div style={s.customerLink}>
          <p style={s.customerText}>
            Customer login-க்கு:
          </p>
          <button
            style={s.customerBtn}
            onClick={() =>
              window.location.href = '/'
            }
          >
            👤 Customer Login →
          </button>
        </div>

        {/* Footer */}
        <p style={s.footer}>
          JSMSTOCK Admin | Madurai
        </p>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#1a252f',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '20px',
    padding: '40px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
  },
  logoBox: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  logoIcon: {
    fontSize: '48px',
    display: 'block',
    marginBottom: '8px',
  },
  logoText: {
    margin: 0,
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#2c3e50',
    fontFamily: 'Arial',
  },
  tagline: {
    margin: '5px 0 0',
    color: '#95a5a6',
    fontSize: '13px',
  },
  adminBadge: {
    backgroundColor: '#2c3e50',
    color: 'white',
    textAlign: 'center',
    padding: '8px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '25px',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  errorBox: {
    backgroundColor: '#fff0f0',
    border: '1px solid #e74c3c',
    color: '#e74c3c',
    padding: '10px 15px',
    borderRadius: '8px',
    fontSize: '13px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#555',
  },
  input: {
    padding: '12px 15px',
    border: '1px solid #ddd',
    borderRadius: '10px',
    fontSize: '15px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'Arial',
  },
  passRow: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  eyeBtn: {
    backgroundColor: '#f8f9fa',
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '10px 12px',
    cursor: 'pointer',
    fontSize: '18px',
  },
  loginBtn: {
    backgroundColor: '#2c3e50',
    color: 'white',
    padding: '14px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: '5px',
    fontFamily: 'Arial',
  },
  customerLink: {
    marginTop: '25px',
    paddingTop: '20px',
    borderTop: '1px solid #eee',
    textAlign: 'center',
  },
  customerText: {
    margin: '0 0 8px',
    color: '#95a5a6',
    fontSize: '13px',
  },
  customerBtn: {
    backgroundColor: '#ecf0f1',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#2c3e50',
    fontWeight: 'bold',
  },
  footer: {
    textAlign: 'center',
    color: '#bdc3c7',
    fontSize: '11px',
    marginTop: '20px',
    marginBottom: 0,
  },
};
